/* VANA Warenkorb-Drawer (Upsell, Progress, Vorbestellung) – ausgelagert 12.10.2026 aus sections/cart-drawer.liquid */
(function () {
  if (window.__VANA_CARTDRAWER_UPSELL_FINAL_DESKTOP_FIX__) return;

  window.__VANA_CARTDRAWER_UPSELL_FINAL_DESKTOP_FIX__ = true;

  var SECTION_HANDLE = 'cart-drawer';

  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

  function qs(selector, rootElement) {
    return (rootElement || document).querySelector(selector);
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) {
        throw new Error('Shopify-Anfrage fehlgeschlagen: ' + response.status);
      }

      return response.json();
    });
  }

  /* --------------------------------------------------
       UPSELL SWIPE
    -------------------------------------------------- */

  function bindUpsellDrag(rootElement) {
    var scrollers = (rootElement || document).querySelectorAll('.vana-cart-upsell__scroller');

    if (!scrollers.length) return;

    scrollers.forEach(function (scroller) {
      if (scroller.dataset.vanaDragBound === 'true') {
        return;
      }

      scroller.dataset.vanaDragBound = 'true';

      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;
      var lastDelta = 0;

      function getCardWidth() {
        var item = scroller.querySelector('.vana-cart-upsell__item');

        if (!item) {
          return scroller.clientWidth;
        }

        return item.getBoundingClientRect().width + 8;
      }

      scroller.addEventListener(
        'touchstart',
        function (event) {
          if (!event.touches || !event.touches.length) {
            return;
          }

          isDown = true;
          startX = event.touches[0].pageX;
          scrollLeft = scroller.scrollLeft;
          lastDelta = 0;
        },
        { passive: true },
      );

      scroller.addEventListener(
        'touchmove',
        function (event) {
          if (!isDown || !event.touches || !event.touches.length) {
            return;
          }

          var currentX = event.touches[0].pageX;

          var delta = startX - currentX;

          lastDelta = delta;

          scroller.scrollLeft = scrollLeft + delta;
        },
        { passive: true },
      );

      function endSwipe() {
        if (!isDown) return;

        isDown = false;

        var cardWidth = getCardWidth();

        if (!cardWidth) return;

        var cardCount = scroller.querySelectorAll('.vana-cart-upsell__item').length;

        var maxIndex = Math.max(0, cardCount - 1);

        var currentIndex = Math.round(scroller.scrollLeft / cardWidth);

        var threshold = 30;

        if (lastDelta > threshold) {
          currentIndex = Math.min(maxIndex, currentIndex + 1);
        } else if (lastDelta < -threshold) {
          currentIndex = Math.max(0, currentIndex - 1);
        }

        scroller.scrollTo({
          left: currentIndex * cardWidth,
          behavior: 'smooth',
        });
      }

      scroller.addEventListener('touchend', endSwipe, { passive: true });

      scroller.addEventListener('touchcancel', endSwipe, { passive: true });
    });
  }

  /* --------------------------------------------------
       DRAWER AKTUALISIEREN
    -------------------------------------------------- */

  function refreshCartDrawer() {
    var drawer = document.getElementById('drawer-cart');

    if (!drawer) return;

    drawer.classList.add('vana-cart--loading');

    return fetchJson(root + '?sections=' + encodeURIComponent(SECTION_HANDLE), {
      credentials: 'same-origin',
    })
      .then(function (json) {
        var html = json[SECTION_HANDLE];

        if (!html) return;

        var parser = new DOMParser();

        var documentFragment = parser.parseFromString(html, 'text/html');

        var currentShipping = qs('[data-vana-cart-shipping]');

        var newShipping = qs('[data-vana-cart-shipping]', documentFragment);

        if (currentShipping && newShipping) {
          currentShipping.innerHTML = newShipping.innerHTML;
        }

        var currentLines = qs('[data-line-items]');

        var newLines = qs('[data-line-items]', documentFragment);

        if (currentLines && newLines) {
          currentLines.innerHTML = newLines.innerHTML;
          normalizeExistingPreorderLineNotices(currentLines);
        }

        var currentPreorderNotice = qs('[data-vana-preorder-cart-notice]');

        var newPreorderNotice = qs('[data-vana-preorder-cart-notice]', documentFragment);

        if (currentPreorderNotice && newPreorderNotice) {
          currentPreorderNotice.innerHTML = newPreorderNotice.innerHTML;
        }

        var currentPreorderRegistry = qs('[data-vana-preorder-registry]');

        var newPreorderRegistry = qs('[data-vana-preorder-registry]', documentFragment);

        if (currentPreorderRegistry && newPreorderRegistry) {
          currentPreorderRegistry.innerHTML = newPreorderRegistry.innerHTML;
        }

        var currentUpsell = qs('[data-vana-upsell-slot]');

        var newUpsell = qs('[data-vana-upsell-slot]', documentFragment);

        if (currentUpsell && newUpsell) {
          currentUpsell.innerHTML = newUpsell.innerHTML;
        }

        var currentPreorderGlobal = qs('[data-vana-preorder-global-slot]');

        var newPreorderGlobal = qs('[data-vana-preorder-global-slot]', documentFragment);

        if (currentPreorderGlobal && newPreorderGlobal) {
          currentPreorderGlobal.innerHTML = newPreorderGlobal.innerHTML;
        }

        var currentSummary = qs('[data-cart-subtotal]');

        var newSummary = qs('[data-cart-subtotal]', documentFragment);

        if (currentSummary && newSummary) {
          currentSummary.innerHTML = newSummary.innerHTML;
        }

        bindUpsellDrag();
        syncVanaCartPreorderNotices();

        if (typeof initVanaProgress === 'function') {
          initVanaProgress();
        }
      })
      .catch(function (error) {
        console.error('VANA cart drawer refresh failed', error);
      })
      .finally(function () {
        drawer.classList.remove('vana-cart--loading');
      });
  }

  /* --------------------------------------------------
       PREORDER POPUP
    -------------------------------------------------- */

  function showVanaPreorderModal(onConfirm) {
    var modal = document.querySelector('[data-vana-preorder-modal]');

    if (!modal) {
      if (typeof onConfirm === 'function') {
        onConfirm();
      }
      return;
    }

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    var confirmButton = modal.querySelector('[data-vana-preorder-modal-confirm]');

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('vana-preorder-modal-open');
    }

    function confirmModal() {
      closeModal();
      if (typeof onConfirm === 'function') {
        onConfirm();
      }
    }

    modal.querySelectorAll('[data-vana-preorder-modal-close]').forEach(function (closeButton) {
      closeButton.onclick = closeModal;
    });

    if (confirmButton) {
      confirmButton.onclick = confirmModal;
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vana-preorder-modal-open');

    if (confirmButton) {
      confirmButton.focus();
    }
  }

  /* --------------------------------------------------
       PREORDER-HINWEISE AN CART-LINE-ITEMS ANHÄNGEN
    -------------------------------------------------- */

  function textContainsPreorder(value) {
    value = String(value || '').toLowerCase();
    return (
      value.indexOf('vorbestell') !== -1 ||
      value.indexOf('preorder') !== -1 ||
      value.indexOf('pre-order') !== -1 ||
      value.indexOf('8–12') !== -1 ||
      value.indexOf('8-12') !== -1
    );
  }

  function cartItemHasPreorderProperties(item) {
    if (!item) return false;

    if (item.selling_plan_allocation) return true;

    var properties = item.properties || {};

    if (Array.isArray(properties)) {
      return properties.some(function (property) {
        return textContainsPreorder(property && (property.value || property[1] || property.last));
      });
    }

    return Object.keys(properties).some(function (key) {
      return textContainsPreorder(key) || textContainsPreorder(properties[key]);
    });
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function findCartLineElementForItem(item) {
    var lineRoot = qs('[data-line-items]');
    if (!lineRoot || !item) return null;

    function cssEscape(value) {
      if (window.CSS && window.CSS.escape) {
        return window.CSS.escape(value);
      }
      return String(value).replace(/"/g, '\\"');
    }

    if (item.key) {
      var keyInput = lineRoot.querySelector('[data-update-cart="' + cssEscape(item.key) + '"]');

      if (keyInput) {
        var node = keyInput;

        while (node && node !== lineRoot) {
          if (
            node.matches &&
            node.matches('.cart__item, .cart-item, [data-cart-item], [data-line-item], li, article, tr')
          ) {
            return node;
          }

          node = node.parentElement;
        }

        node = keyInput.parentElement;

        while (node && node.parentElement !== lineRoot) {
          node = node.parentElement;
        }

        if (node && node !== lineRoot) return node;
      }
    }

    var productTitle = normalizeText(item.product_title || item.title);
    var variantTitle = normalizeText(item.variant_title);

    var candidates = Array.prototype.slice.call(
      lineRoot.querySelectorAll('.cart__item, .cart-item, [data-cart-item], [data-line-item], li, article, tr'),
    );

    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = candidates[i];
      var candidateText = normalizeText(candidate.textContent);

      if (
        productTitle &&
        candidateText.indexOf(productTitle) !== -1 &&
        (!variantTitle || candidateText.indexOf(variantTitle) !== -1 || variantTitle === 'default title')
      ) {
        return candidate;
      }
    }

    return null;
  }

  function createPreorderLineNotice() {
    var notice = document.createElement('div');
    notice.className = 'vana-cart-line-preorder vana-cart-line-preorder--js';
    notice.innerHTML =
      '<div class="vana-cart-line-preorder__title">Vorbestellung 💗</div>' +
      '<div class="vana-cart-line-preorder__text">Versand in ca. 8–12 Wochen.</div>';
    return notice;
  }

  function normalizePreorderLineNotice(notice) {
    if (!notice) return;
    notice.classList.add('vana-cart-line-preorder');
    notice.innerHTML =
      '<div class="vana-cart-line-preorder__title">Vorbestellung 💗</div>' +
      '<div class="vana-cart-line-preorder__text">Versand in ca. 8–12 Wochen.</div>';
  }

  function normalizeExistingPreorderLineNotices(rootElement) {
    var rootNode = rootElement || document;
    rootNode
      .querySelectorAll(
        '#drawer-cart [data-line-items] .vana-cart-line-preorder, #drawer-cart [data-line-items] .vana-cart-preorder',
      )
      .forEach(function (notice) {
        normalizePreorderLineNotice(notice);
      });

    rootNode
      .querySelectorAll(
        '#drawer-cart [data-line-items] div, #drawer-cart [data-line-items] p, #drawer-cart [data-line-items] span',
      )
      .forEach(function (node) {
        if (
          node.classList &&
          (node.classList.contains('vana-cart-line-preorder') || node.classList.contains('vana-cart-preorder'))
        )
          return;

        var text = normalizeText(node.textContent);

        if (text.indexOf('Exklusiv vorbestellt') !== -1 && text.indexOf('8') !== -1 && text.length < 180) {
          node.classList.add('vana-cart-preorder');
          normalizePreorderLineNotice(node);
        }
      });
  }

  function appendPreorderNoticeToLine(lineElement, item) {
    if (!lineElement) return;

    var existingNotice = lineElement.querySelector('.vana-cart-line-preorder, .vana-cart-preorder');

    if (existingNotice) {
      normalizePreorderLineNotice(existingNotice);
      return;
    }

    var notice = createPreorderLineNotice();
    lineElement.classList.add('vana-cart-line--js-preorder');

    var productTitle = normalizeText(item && (item.product_title || item.title));

    /*
        Zuerst versuchen wir, ausgehend von Mengen-/Preis-Elementen den rechten
        Inhaltsbereich zu finden. Das ist deutlich stabiler als an den äußeren
        Line-Item-Container anzuhängen.
      */
    var quantityOrPrice = lineElement.querySelector(
      '[data-quantity-selector], .quantity, .cart__item__quantity, .cart-item__quantity, .cart__item__price, .cart-item__price, [data-cart-item-price]',
    );

    var contentFromControls = quantityOrPrice ? quantityOrPrice.parentElement : null;

    while (
      contentFromControls &&
      contentFromControls !== lineElement &&
      productTitle &&
      normalizeText(contentFromControls.textContent).indexOf(productTitle) === -1
    ) {
      contentFromControls = contentFromControls.parentElement;
    }

    if (
      contentFromControls &&
      contentFromControls !== lineElement &&
      productTitle &&
      normalizeText(contentFromControls.textContent).indexOf(productTitle) !== -1
    ) {
      var controlTitleCandidates = Array.prototype.slice.call(
        contentFromControls.querySelectorAll('a, p, span, div, h1, h2, h3, h4, [class*="title"], [class*="name"]'),
      );

      for (var c = 0; c < controlTitleCandidates.length; c += 1) {
        var controlTitleElement = controlTitleCandidates[c];
        var controlTitleText = normalizeText(controlTitleElement.textContent);

        if (controlTitleText.indexOf(productTitle) !== -1 && controlTitleText.length <= productTitle.length + 90) {
          controlTitleElement.insertAdjacentElement('afterend', notice);
          return;
        }
      }

      contentFromControls.insertBefore(notice, quantityOrPrice);
      return;
    }

    /*
        Danach direkt unter den Produkttitel setzen.
        Nicht an den äußeren Line-Item-Container hängen, sonst landet der Hinweis
        bei manchen Theme-Layouts links/unter dem Bild.
      */
    if (productTitle) {
      var titleCandidates = Array.prototype.slice.call(
        lineElement.querySelectorAll(
          'a, p, span, div, h1, h2, h3, h4, [class*="title"], [class*="name"], .cart__item__title, .cart-item__name, .cart__item__name',
        ),
      );

      for (var i = 0; i < titleCandidates.length; i += 1) {
        var titleElement = titleCandidates[i];
        var titleText = normalizeText(titleElement.textContent);

        if (titleText.indexOf(productTitle) !== -1 && titleText.length <= productTitle.length + 90) {
          titleElement.insertAdjacentElement('afterend', notice);
          return;
        }
      }
    }

    /* Fallback: falls es einen klaren rechten Inhaltsbereich gibt, dort möglichst weit oben einfügen. */
    var target = lineElement.querySelector(
      '.cart__item__content, .cart-item__details, .cart__item__details, .cart-item__content, .cart-item__info, [data-cart-item-details]',
    );

    if (target) {
      var priceOrQty = target.querySelector(
        '.cart__item__price, .cart-item__price, [data-cart-item-price], [data-quantity-selector]',
      );
      if (priceOrQty) {
        priceOrQty.insertAdjacentElement('beforebegin', notice);
      } else {
        target.insertBefore(notice, target.children[1] || null);
      }
      return;
    }

    /* Letzter Fallback: rechte Hälfte erzwingen, damit es nicht links unter dem Bild klebt. */
    notice.classList.add('vana-cart-line-preorder--js-fallback');
    lineElement.appendChild(notice);
  }

  function removeJsPreorderLineNotices() {
    document.querySelectorAll('#drawer-cart .vana-cart-line--js-preorder').forEach(function (line) {
      line.classList.remove('vana-cart-line--js-preorder');
    });

    document.querySelectorAll('#drawer-cart .vana-cart-line-preorder--js').forEach(function (notice) {
      notice.remove();
    });
  }

  function getPreorderItemsFromLiquidRegistry() {
    var registry = document.querySelector('#drawer-cart [data-vana-preorder-registry]');

    if (!registry) return [];

    return Array.prototype.slice
      .call(registry.querySelectorAll('[data-vana-preorder-item-key]'))
      .map(function (entry) {
        return {
          key: entry.getAttribute('data-vana-preorder-item-key'),
          product_title: entry.getAttribute('data-vana-preorder-item-title'),
          variant_title: entry.getAttribute('data-vana-preorder-variant-title'),
        };
      })
      .filter(function (item) {
        return item.key || item.product_title;
      });
  }

  function cartItemHasPreorderProperties(item) {
    if (!item || !item.properties) return false;

    return Object.keys(item.properties).some(function (key) {
      var value = item.properties[key];
      var keyText = normalizeText(key);
      var valueText = normalizeText(value);

      return (
        keyText.indexOf('preorder') !== -1 ||
        keyText.indexOf('vorbestell') !== -1 ||
        valueText.indexOf('preorder') !== -1 ||
        valueText.indexOf('pre-order') !== -1 ||
        valueText.indexOf('vorbestell') !== -1 ||
        valueText.indexOf('8–12') !== -1 ||
        valueText.indexOf('8-12') !== -1
      );
    });
  }

  function getStoredPreorderVariantIds() {
    if (!window.localStorage) return {};

    try {
      return JSON.parse(window.localStorage.getItem('vana_preorder_variant_ids') || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function rememberPreorderVariantId(variantId) {
    if (!variantId || !window.localStorage) return;

    try {
      var stored = getStoredPreorderVariantIds();
      stored[String(variantId)] = Date.now();
      window.localStorage.setItem('vana_preorder_variant_ids', JSON.stringify(stored));
    } catch (error) {}
  }

  function pruneStoredPreorderVariantIds(cart) {
    if (!cart || !cart.items || !window.localStorage) return;

    try {
      var stored = getStoredPreorderVariantIds();
      var activeVariantIds = {};

      cart.items.forEach(function (item) {
        var variantId = item.variant_id || item.id;
        if (variantId) activeVariantIds[String(variantId)] = true;
      });

      Object.keys(stored).forEach(function (variantId) {
        var age = Date.now() - Number(stored[variantId] || 0);

        if (!activeVariantIds[variantId] || age > 7 * 24 * 60 * 60 * 1000) {
          delete stored[variantId];
        }
      });

      window.localStorage.setItem('vana_preorder_variant_ids', JSON.stringify(stored));
    } catch (error) {}
  }

  function runtimeCartItemIsPreorder(item) {
    if (!item) return false;
    if (cartItemHasPreorderProperties(item)) return true;

    var variantId = item.variant_id || item.id;
    var stored = getStoredPreorderVariantIds();

    return !!(variantId && stored[String(variantId)]);
  }

  function syncVanaCartPreorderNoticesFromRuntimeCart() {
    return fetchJson('/cart.js', {
      credentials: 'same-origin',
    })
      .then(function (cart) {
        if (!cart || !cart.items) return;

        pruneStoredPreorderVariantIds(cart);

        cart.items.forEach(function (item) {
          if (!runtimeCartItemIsPreorder(item)) return;

          var lineElement = findCartLineElementForItem(item);
          appendPreorderNoticeToLine(lineElement, item);
        });
      })
      .catch(function (error) {
        console.error('VANA preorder runtime sync failed', error);
      });
  }

  function syncVanaCartPreorderNotices() {
    var lineRoot = qs('[data-line-items]');

    if (!lineRoot) return;

    normalizeExistingPreorderLineNotices(lineRoot);

    getPreorderItemsFromLiquidRegistry().forEach(function (item) {
      var lineElement = findCartLineElementForItem(item);
      appendPreorderNoticeToLine(lineElement, item);
    });

    syncVanaCartPreorderNoticesFromRuntimeCart();
  }

  /* --------------------------------------------------
       UPSELL HINZUFÜGEN
    -------------------------------------------------- */

  function showCartError(message) {
    var errorBox = document.querySelector('#drawer-cart [data-form-errors]');

    if (!errorBox) return;

    errorBox.textContent = message;
    errorBox.style.display = 'block';

    window.clearTimeout(window.__VANA_CART_ERROR_TIMEOUT__);

    window.__VANA_CART_ERROR_TIMEOUT__ = window.setTimeout(function () {
      errorBox.style.display = 'none';
      errorBox.textContent = '';
    }, 3500);
  }

  function handleUpsellButton(event, upsellButton, confirmed) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }
    }

    if (!upsellButton || upsellButton.disabled) return;

    var upsellContainer = upsellButton.closest('.vana-cart-upsell__item');

    var variantSelect = upsellContainer ? upsellContainer.querySelector('[data-upsell-variant-select]') : null;

    var variantId = variantSelect ? variantSelect.value : upsellButton.getAttribute('data-upsell-variant-id');

    if (!variantId) return;

    var selectedOption = variantSelect ? variantSelect.options[variantSelect.selectedIndex] : null;

    var sellingPlanId = selectedOption ? selectedOption.getAttribute('data-selling-plan-id') : null;

    if (!sellingPlanId && upsellContainer) {
      sellingPlanId = upsellContainer.getAttribute('data-upsell-selling-plan-id');
    }

    var isPreorder =
      (upsellContainer && upsellContainer.getAttribute('data-upsell-preorder') === 'true') ||
      (selectedOption && selectedOption.getAttribute('data-variant-preorder') === 'true');

    if (isPreorder && confirmed !== true) {
      showVanaPreorderModal(function () {
        handleUpsellButton(null, upsellButton, true);
      });

      return;
    }

    var addPayload = {
      id: Number(variantId),
      quantity: 1,
    };

    if (isPreorder || sellingPlanId) {
      addPayload.properties = {
        Hinweis: 'Vorbestellung',
        Lieferzeit: 'Versand in ca. 8–12 Wochen',
        _vana_preorder: 'true',
      };
    }

    upsellButton.disabled = true;
    upsellButton.textContent = 'Wird hinzugefügt…';

    fetchJson('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        Accept: 'application/json',
      },
      body: JSON.stringify(addPayload),
    })
      .then(function () {
        if (isPreorder || sellingPlanId) {
          rememberPreorderVariantId(variantId);
        }

        return refreshCartDrawer();
      })
      .then(function () {
        return syncVanaCartPreorderNotices();
      })
      .catch(function (error) {
        showCartError('Der Artikel konnte gerade nicht hinzugefügt werden.');

        console.error('Upsell add error', error);
      })
      .finally(function () {
        upsellButton.disabled = false;
        upsellButton.textContent = upsellButton.getAttribute('data-upsell-add-label') || 'In den Warenkorb';
      });
  }

  window.vanaHandleUpsellAdd = function (upsellButton) {
    handleUpsellButton(null, upsellButton, false);
  };

  /* --------------------------------------------------
       KLICK- UND TOUCH-HANDLER
    -------------------------------------------------- */

  document.addEventListener(
    'touchstart',
    function (event) {
      if (!event.target || !event.target.closest) return;

      var upsellButton = event.target.closest('#drawer-cart [data-upsell-add]');

      if (!upsellButton || !event.touches || !event.touches.length) return;

      upsellButton.dataset.vanaTouchStartX = String(event.touches[0].pageX);
      upsellButton.dataset.vanaTouchStartY = String(event.touches[0].pageY);
    },
    true,
  );

  document.addEventListener(
    'touchend',
    function (event) {
      if (!event.target || !event.target.closest) return;

      var upsellButton = event.target.closest('#drawer-cart [data-upsell-add]');

      if (!upsellButton || !event.changedTouches || !event.changedTouches.length) return;

      var startX = parseFloat(upsellButton.dataset.vanaTouchStartX || '0');
      var startY = parseFloat(upsellButton.dataset.vanaTouchStartY || '0');
      var endX = event.changedTouches[0].pageX;
      var endY = event.changedTouches[0].pageY;
      var distance = Math.sqrt(Math.pow(endX - startX, 2) + Math.pow(endY - startY, 2));

      if (distance > 14) return;

      window.__VANA_UPSELL_TOUCH_UNTIL__ = Date.now() + 700;
      handleUpsellButton(event, upsellButton, false);
    },
    true,
  );

  document.addEventListener(
    'pointerup',
    function (event) {
      if (!event.target || !event.target.closest) return;

      var upsellButton = event.target.closest('#drawer-cart [data-upsell-add]');

      if (!upsellButton) return;

      if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') {
        return;
      }

      window.__VANA_UPSELL_POINTER_UNTIL__ = Date.now() + 700;
      handleUpsellButton(event, upsellButton, false);
    },
    true,
  );

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target || !event.target.closest) return;

      var preorderMoreButton = event.target.closest('#drawer-cart [data-vana-preorder-more]');

      if (preorderMoreButton) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }

        showVanaPreorderModal(null);
        return;
      }

      var upsellButton = event.target.closest('#drawer-cart [data-upsell-add]');

      if (upsellButton) {
        if (
          (window.__VANA_UPSELL_TOUCH_UNTIL__ && Date.now() < window.__VANA_UPSELL_TOUCH_UNTIL__) ||
          (window.__VANA_UPSELL_POINTER_UNTIL__ && Date.now() < window.__VANA_UPSELL_POINTER_UNTIL__)
        ) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
          }
          return;
        }

        handleUpsellButton(event, upsellButton, false);
        return;
      }

      /* 2. MENGE ERHÖHEN ODER VERRINGERN */

      var quantityButton = event.target.closest(
        '#drawer-cart [data-increase-quantity], ' + '#drawer-cart [data-decrease-quantity]',
      );

      if (quantityButton) {
        event.preventDefault();
        event.stopPropagation();

        var quantityWrapper = quantityButton.closest('[data-quantity-selector]');

        var quantityInput = quantityWrapper ? quantityWrapper.querySelector('[data-quantity-input]') : null;

        if (!quantityInput) return;

        var itemKey = quantityInput.getAttribute('data-update-cart');

        var currentQuantity = parseInt(quantityInput.value, 10) || 0;

        var newQuantity = currentQuantity;

        if (quantityButton.hasAttribute('data-increase-quantity')) {
          newQuantity = currentQuantity + 1;
        }

        if (quantityButton.hasAttribute('data-decrease-quantity')) {
          newQuantity = Math.max(0, currentQuantity - 1);
        }

        if (!itemKey || newQuantity === currentQuantity) {
          return;
        }

        quantityButton.disabled = true;
        quantityInput.value = newQuantity;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: newQuantity,
          }),
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) {
                var error = new Error(data.description || data.message || 'Menge konnte nicht geändert werden.');

                error.status = response.status;
                throw error;
              }

              return data;
            });
          })
          .then(function () {
            refreshCartDrawer();
          })
          .then(function () {
            syncVanaCartPreorderNotices();
          })
          .catch(function (error) {
            quantityInput.value = currentQuantity;

            showCartError(
              quantityButton.hasAttribute('data-increase-quantity')
                ? 'Maximale verfügbare Menge erreicht.'
                : 'Die Menge konnte nicht geändert werden.',
            );

            console.error('Drawer quantity error', error);
          })
          .finally(function () {
            quantityButton.disabled = false;
          });

        return;
      }

      /* 3. ARTIKEL ENTFERNEN */

      var removeLink = event.target.closest('#drawer-cart a');

      if (removeLink && /\/cart\/change/.test(removeLink.getAttribute('href') || '')) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        try {
          var removeUrl = new URL(removeLink.href);
          var quantity = removeUrl.searchParams.get('quantity') || '0';

          if (String(quantity) !== '0') return;

          var removeLineElement = removeLink.closest(
            '.cart__item, .cart-item, [data-cart-item], [data-line-item], li, article, tr',
          );

          var removeInput = removeLineElement ? removeLineElement.querySelector('[data-update-cart]') : null;

          var removeItemKey = removeInput ? removeInput.getAttribute('data-update-cart') : null;

          var changePayload = {
            quantity: 0,
          };

          if (removeItemKey) {
            changePayload.id = removeItemKey;
          } else {
            var line = removeUrl.searchParams.get('line');

            if (!line || Number(line) < 1) {
              console.error('Drawer remove skipped: missing item key and invalid line');
              return;
            }

            changePayload.line = Number(line);
          }

          removeLink.style.pointerEvents = 'none';
          fetchJson('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              Accept: 'application/json',
            },
            body: JSON.stringify(changePayload),
          })
            .then(function () {
              refreshCartDrawer();
            })
            .then(function () {
              syncVanaCartPreorderNotices();
            })
            .catch(function (error) {
              removeLink.style.pointerEvents = '';
              console.error('Drawer remove error', error);
            });
        } catch (error) {
          console.error('URL parse error for cart remove', error);
        }
      }
    },
    true,
  );

  /* --------------------------------------------------
       UPSELL VARIANTE: LABEL / PREORDER-HINWEIS AKTUALISIEREN
    -------------------------------------------------- */

  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.closest) return;

    var variantSelect = event.target.closest('#drawer-cart [data-upsell-variant-select]');

    if (!variantSelect) return;

    var upsellContainer = variantSelect.closest('.vana-cart-upsell__item');

    if (!upsellContainer) return;

    var selectedOption = variantSelect.options[variantSelect.selectedIndex];

    var selectedSellingPlanId = selectedOption ? selectedOption.getAttribute('data-selling-plan-id') : '';

    if (selectedSellingPlanId) {
      upsellContainer.setAttribute('data-upsell-selling-plan-id', selectedSellingPlanId);
    } else {
      upsellContainer.removeAttribute('data-upsell-selling-plan-id');
    }

    upsellContainer.setAttribute(
      'data-upsell-preorder',
      selectedOption && selectedOption.getAttribute('data-variant-preorder') === 'true' ? 'true' : 'false',
    );

    var optionIsPreorder = selectedOption && selectedOption.getAttribute('data-variant-preorder') === 'true';

    var isPreorder = optionIsPreorder;

    var button = upsellContainer.querySelector('[data-upsell-add]');

    if (button) {
      var label = isPreorder ? 'Jetzt vorbestellen' : 'In den Warenkorb';

      button.textContent = label;
      button.setAttribute('data-upsell-add-label', label);
      button.classList.toggle('vana-cart-upsell__link--preorder', isPreorder);
    }

    var preorderNotice = upsellContainer.querySelector('.vana-cart-upsell__preorder');

    if (!preorderNotice && isPreorder) {
      preorderNotice = document.createElement('div');
      preorderNotice.className = 'vana-cart-upsell__preorder';
      preorderNotice.textContent = 'Vorbestellung · 8–12 Wochen';

      var title = upsellContainer.querySelector('.vana-cart-upsell__title');

      if (title && title.parentNode) {
        title.parentNode.insertBefore(preorderNotice, title.nextSibling);
      }
    }

    if (preorderNotice) {
      preorderNotice.style.display = isPreorder ? '' : 'none';
    }
  });

  /* --------------------------------------------------
       THEME CART EVENT
    -------------------------------------------------- */

  document.addEventListener('theme:cart:change', function () {
    refreshCartDrawer();
  });

  /* --------------------------------------------------
       PROGRESS BAR
    -------------------------------------------------- */

  function initVanaProgress() {
    var progressRoot = document.getElementById('vana-cart-progress-bar');

    if (!progressRoot) return;

    var shippingThreshold = parseInt(progressRoot.getAttribute('data-shipping-threshold-cents'), 10) || 0;

    var discountThreshold = parseInt(progressRoot.getAttribute('data-discount-threshold-cents'), 10) || 0;

    fetchJson('/cart.js', {
      credentials: 'same-origin',
    })
      .then(function (cart) {
        var total = cart.original_total_price;

        var fillElement = progressRoot.querySelector('.vana-kite-progress__fill');

        var percentage = 0;

        if (shippingThreshold > 0 && total <= shippingThreshold) {
          percentage = (total / shippingThreshold) * 50;
        } else if (discountThreshold > shippingThreshold) {
          percentage = 50 + ((total - shippingThreshold) / (discountThreshold - shippingThreshold)) * 50;
        } else if (total > 0) {
          percentage = 100;
        }

        percentage = Math.max(0, Math.min(100, percentage));

        if (fillElement) {
          fillElement.style.width = percentage + '%';
        }

        var steps = {
          returns: {
            selector: '.vana-kite-progress__dot--returns',
            position: '0%',
            active: true,
          },
          shipping: {
            selector: '.vana-kite-progress__dot--shipping',
            position: '50%',
            active: total >= shippingThreshold,
          },
          discount: {
            selector: '.vana-kite-progress__dot--discount',
            position: '100%',
            active: total >= discountThreshold,
          },
        };

        Object.keys(steps).forEach(function (key) {
          var config = steps[key];

          var dot = progressRoot.querySelector(config.selector);

          if (dot) {
            dot.style.left = config.position;

            dot.classList.toggle('is-active', config.active);
          }

          progressRoot.querySelectorAll('.vana-kite-step[data-step="' + key + '"]').forEach(function (step) {
            step.classList.toggle('vana-kite-step--active', config.active);
          });
        });
      })
      .catch(function (error) {
        console.error('VANA Progress Error', error);
      });
  }

  function onVanaDomReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  onVanaDomReady(function () {
    bindUpsellDrag();
    syncVanaCartPreorderNotices();
    initVanaProgress();
  });
})();
